let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4RCMc")).then(() => parcelRequire('6HiID'));